import BreadcrumbsAndViewBanner from '../../components/breadcrumbs-and-view-banner/breadcrumbs-and-view-banner';
import { RecallPageBreadCrumb } from './recalls-util';
import React from 'react';
import { nameplateMakeModelYearUtil } from '../../../components/utils/nameplate-model-year-util/nameplate-make-model-year-util';

interface Props {
    vinToSearch: string;
    displayName: string;
    year: string;
    recallsContent: any;
    recallsHref: string | null;
}

export const BreadcrumbsAndViewBannerContainer = (props: Props) => {
    const modelAndYear =
        props.displayName && props.year
            ? nameplateMakeModelYearUtil(props.displayName, props.year)
            : '';
    return (
        <BreadcrumbsAndViewBanner
            currentPage={
                props.vinToSearch ? `${props.vinToSearch}` : modelAndYear
            }
            previousCrumb={RecallPageBreadCrumb(
                props.recallsContent?.title,
                `${props.recallsHref}`
            )}
            hashId={'support'}
        />
    );
};
